import { render, staticRenderFns } from "./RiseupBotPlayground.vue?vue&type=template&id=3619832c&scoped=true&"
import script from "./RiseupBotPlayground.vue?vue&type=script&lang=js&"
export * from "./RiseupBotPlayground.vue?vue&type=script&lang=js&"
import style0 from "./RiseupBotPlayground.vue?vue&type=style&index=0&id=3619832c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619832c",
  null
  
)

export default component.exports